import React, { useState , useRef ,useEffect} from "react";
import {
    Box,
    Typography,
    Button,
    Modal,
    IconButton,
    InputBase
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { useSelector ,useDispatch} from "react-redux";
import { Toast } from 'primereact/toast';
import { ProductBannerTable } from "../../sub_components/product_banner_table";
import CustomAxios from "../../utils/CustomAxios";
import {useGetProductBanners} from '../../Components/globalFunctions'
import { updateModal,updateEdit,updateProductBannerDetails, updateSearchProductBanner} from "../../Redux/product-banner";


export default function ProductBanner() {
    const dispatch = useDispatch();
    const { modal, edit, productBannerDetails } = useSelector(state => state.productBanner);
    const searchValue = useSelector(state => state.productBanner.searchProductBanner);
    const toast = useRef(null);
    const [errors, setErrors] = useState({});
    const getProductBanner = useGetProductBanners()
    
    const inventory = useSelector((state) => state.inventory.inventory);
    const user_role = localStorage.getItem('role');
    
    // Get assigned hubs for role-based filtering
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    // Build inventory options: show all, but disable unassigned for restricted roles
    const filteredInventory = (inventory || []).map((inv) => {
        const isAssigned = assignedHubs.includes(inv.value);
        return {
            ...inv,
            name: inv.name ?? 'Not assigned hub',
            disabled: ['admin', 'supervisor', 'customer_engagement_admin'].includes(user_role) ? !isAssigned : false
        };
    });

    // Filter to only show assigned hubs for restricted roles
    const availableInventory = ['admin', 'supervisor', 'customer_engagement_admin'].includes(user_role) 
        ? filteredInventory.filter(inv => assignedHubs.includes(inv.value))
        : filteredInventory;

    // Check if we should show dropdown (multiple hubs available) or auto-select (single hub)
    const shouldShowDropdown = availableInventory.length > 1;
    const singleAssignedHub = availableInventory.length === 1 ? availableInventory[0] : null;

    // Form state
    const [formData, setFormData] = useState({
        inventory: [],
        name: "",
        content: "",
        status: ""
    });

  const handleAddBanner = () => {
  dispatch(updateProductBannerDetails({}));
  dispatch(updateEdit(false));
  dispatch(updateModal(true));
};

    const statusOptions = ["Active", "Inactive"];

  

    const productBanners = useSelector(state => state.productBanner.productBanners || []);
    const totalBannersCount = productBanners.length;
    const activeBannersCount = productBanners.filter(banner => banner.status === true).length;


 const handleClose = () => {
  setErrors({}); 
  if (!edit) {
    setFormData({
      inventory: [],
      name: "",
      content: "",
      status: ""
    });
  }

  dispatch(updateModal(false));
  dispatch(updateEdit(false));
  dispatch(updateProductBannerDetails({}));
};

    useEffect(() => {
    if (modal) {
        // For edit mode, use existing inventory or auto-select single hub
        let inventoryValue = productBannerDetails.inventory || [];
        
        // If no existing inventory and only one hub assigned, auto-select it
        if (!inventoryValue.length && singleAssignedHub) {
            inventoryValue = [singleAssignedHub];
        }
        
        setFormData({
        inventory: inventoryValue,
        name: productBannerDetails.name || "",
        content: productBannerDetails.content || "",
        status: edit
            ? (productBannerDetails.status === true ? "Active" : "Inactive")
            : "",
        });
    } else {
        // For new banner, auto-select single hub if only one assigned
        const initialInventory = singleAssignedHub ? [singleAssignedHub] : [];
        
        setFormData({
        inventory: initialInventory,
        name: "",
        content: "",
        status: "",
        });
    }
    }, [modal, productBannerDetails, edit, singleAssignedHub]);

    // Check if user can manage product banners (create, edit, delete) - AFTER all hooks
    const canManageBanners = ['super_admin', 'admin', 'supervisor', 'customer_engagement_admin','merchant'].includes(user_role);

    if (!canManageBanners) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <Typography variant="h6" color="error">
                    Access Denied
                </Typography>
                <Typography>
                    You don't have permission to manage product banners. You can only send push notifications.
                </Typography>
            </Box>
        );
    }

    const handleChange = (e, nameOverride) => {
        // For PrimeReact MultiSelect and Dropdown
        if (e.value !== undefined) {
            const fieldName = nameOverride || e.target?.name || "";
            setFormData((prev) => ({ ...prev, [fieldName || "inventory"]: e.value }));
        } 
        // For MUI InputBase and standard inputs
        else if (e.target) {
            setFormData((prev) => ({ ...prev, [nameOverride || e.target.name]: e.target.value }));
        }
    };

const handleSave = async () => {
    if (!validate()) return; 

    try {
        const payload = {
            inventory_ids: formData.inventory.map(item => item.id || item),
            name: formData.name,
            content: formData.content,
            status: formData.status === "Active"
        };

        if (edit && productBannerDetails.id) {
            await CustomAxios.put(`product_banner/${productBannerDetails.id}/`, payload);
        } else {
            await CustomAxios.post("product_banner/", payload);
        }
          await getProductBanner();
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Banner saved successfully', life: 3000 });
        handleClose();
    } catch (error) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save banner', life: 3000 });
        console.error("Error saving banner:", error);
    }
};
 const handleSearchChange = (e) => {
    dispatch(updateSearchProductBanner(e.target.value));
  };

  const validate = () => {
    const newErrors = {};
    
    // For inventory validation, check if we have inventory selected or if single hub is auto-selected
    if (!formData.inventory || formData.inventory.length === 0) {
        if (singleAssignedHub) {
            // If single hub is assigned, auto-select it
            setFormData(prev => ({ ...prev, inventory: [singleAssignedHub] }));
        } else {
            newErrors.inventory = "Please select at least one inventory.";
        }
    }
    if (!formData.name?.trim()) {
        newErrors.name = "Name is required.";
    }
    if (!formData.content?.trim()) {
        newErrors.content = "Content is required.";
    } else {
        const charCount = formData.content.trim().length;
        if (charCount > 50) {
            newErrors.content = `Content cannot exceed 50 characters. Currently: ${charCount}`;
        }
    }
    if (!formData.status) {
        newErrors.status = "Please select a status.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};
    return (
        <>
        <Toast ref={toast} />
         <Box p={3}>
            {/* Top Header */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mb: 3 }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>
                    Product Banner
                </Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>
                    Banners
                </Typography>
            </Box>

            {/* Stats Row */}
            <Box sx={{ height: "94px", width: "100%", backgroundColor: "white", display: "flex", alignItems: "center", mb: 3 }}>
                <Box sx={{ width: "100%" }}>
                    <Typography sx={{ fontSize: "24px", fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>
                        {totalBannersCount}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>
                        Total Banners
                    </Typography>
                </Box>
                <Box sx={{ width: "100%" }}>
                    <Typography sx={{ fontSize: "24px", fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>
                        {activeBannersCount}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>
                        Active Banners
                    </Typography>
                </Box>
            </Box>

            {/* Search + Add Button Section */}
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", mb: 3 }}>
                {/* Search Box */}
                <Box sx={{ position: "relative" }}>
                    <InputBase
                        sx={{
                            backgroundColor: "white",
                            height: "32px",
                            width: "100%",
                            maxWidth: "268px",
                            borderRadius: "2px",
                            border: "1px solid",
                            borderColor: "secondary.border",
                            padding: "5px 12px 5px 40px",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            color: "black"
                        }}
                        placeholder="Search banners"
                        value={searchValue}
                        onChange={handleSearchChange}
                    />
                    <SearchIcon
                        sx={{
                            position: "absolute",
                            left: "12px",
                            top: "5px",
                            width: "20px",
                            height: "20px",
                            color: "#666"
                        }}
                    />
                </Box>

                {/* Add Banner Button */}
                <Button variant="contained" sx={{ textTransform: "none" }} onClick={handleAddBanner}>
                     Add Banner
                </Button>
            </Box>

            {/* Table Section */}
            <ProductBannerTable />

            {/* Modal */}
            <Modal open={modal} onClose={handleClose} sx={{ zIndex: 1000 }}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "100%",
                        maxWidth: "600px",
                        height: "auto",
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            height: "46px",
                            padding: "12px 24px",
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>
                           {edit ? "Edit Banner" : "Add Banner"}
                        </Typography>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Body */}
                    <Box sx={{ padding: "24px", display: "flex", flexDirection: "column", gap: "16px" }}>
                        {/* Inventory List */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Inventory List</Typography>
                            
                            {/* Show dropdown only if multiple hubs available */}
                            {shouldShowDropdown ? (
                                <MultiSelect
                                    value={formData.inventory}
                                    options={availableInventory}
                                    onChange={(e) => handleChange(e, "inventory")}
                                    optionValue="value"
                                    optionLabel="name"
                                    optionDisabled="disabled"
                                    placeholder="Select Inventory"
                                    className="w-full md:w-14rem"
                                    showClear={true}
                                />
                            ) : (
                                /* Show selected hub info when only one hub assigned */
                                <Box sx={{ 
                                    backgroundColor: "white",
                                    width: "100%",
                                    height: "32px",
                                    borderRadius: "2px",
                                    border: "1px solid",
                                    borderColor: "secondary.border",
                                    padding: "5px 12px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    lineHeight: "22px",
                                    color: "black",
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    {singleAssignedHub ? singleAssignedHub.name : "No hub assigned"}
                                </Box>
                            )}
                            
                            {errors.inventory && (
                                <Typography sx={{ color: "red", fontSize: "12px" }}>{errors.inventory}</Typography>
                            )}
                        </Box>

                        {/* Name */}
                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Name</Typography>
                            <InputBase
                                value={formData.name}
                                sx={{
                                    backgroundColor: "white",
                                    width: "100%",
                                    height: "32px",
                                    borderRadius: "2px",
                                    border: "1px solid",
                                    borderColor: "secondary.border",
                                    padding: "5px 12px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    lineHeight: "22px",
                                    color: "black"
                                }}
                                placeholder="Enter Name"
                                name="name"
                                onChange={handleChange}
                            />
                                {errors.name && (
                                    <Typography sx={{ color: "red", fontSize: "12px" }}>{errors.name}</Typography>
                                )}
                        </Box>

                        {/* Content */}
                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Content</Typography>
                            <InputBase
                                value={formData.content}
                                sx={{
                                    backgroundColor: "white",
                                    width: "100%",
                                    height: "32px",
                                    borderRadius: "2px",
                                    border: "1px solid",
                                    borderColor: "secondary.border",
                                    padding: "5px 12px",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    lineHeight: "22px",
                                    color: "black"
                                }}
                                placeholder="Enter Content"
                                name="content"
                                onChange={handleChange}
                            />
                                {errors.content && (
                                    <Typography sx={{ color: "red", fontSize: "12px" }}>{errors.content}</Typography>
                                )}
                        </Box>

                        {/* Status */}
                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Status</Typography>
                            <Dropdown
                                value={formData.status}
                                onChange={(e) => handleChange(e, "status")}
                                options={statusOptions.map((status) => ({ label: status, value: status }))}
                                placeholder="Select Status"
                                className="w-full md:w-14rem"
                            />
                            {errors.status && (
                                <Typography sx={{ color: "red", fontSize: "12px" }}>{errors.status}</Typography>
                            )}
                        </Box>
                    </Box>

                    {/* Footer */}
                    <Box
                        sx={{
                            padding: "12px 24px",
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px"
                        }}
                    >
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button variant="contained" onClick={handleSave}>
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
        </>
       
    );
}






